export default __webpack_public_path__ + "static/media/Tema 5 b.773afa38.png";